import { useNavigate } from "react-router-dom";

const MaintenancePage = ({ type }: { type: string }) => {
    const navigate = useNavigate();
    return (
        <>
            {type === 'main' &&
                <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white p-6 text-slate-900 font-sans">
                    <div className="bg-white rounded-2xl shadow-xl p-10 grid md:grid-cols-[1fr_360px] gap-8 items-center max-w-5xl w-full">
                        <section className="flex flex-col gap-5">
                            <div className="flex gap-5 items-center">
                                <div className="w-40 h-40 flex items-center justify-center bg-gradient-to-b from-cyan-100/30 to-cyan-50 border border-cyan-100 rounded-xl">
                                    <svg
                                        width="110"
                                        height="110"
                                        viewBox="0 0 110 110"
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-label="Иллюстрация: технические работы"
                                    >
                                        <defs>
                                            <linearGradient id="g1" x1="0" x2="1">
                                                <stop offset="0" stopColor="#06b6d4" />
                                                <stop offset="1" stopColor="#0891b2" />
                                            </linearGradient>
                                        </defs>
                                        <circle cx="55" cy="55" r="52" fill="url(#g1)" opacity="0.12" />
                                        <g transform="translate(14,14)" fill="none" stroke="#0f172a" strokeWidth="2">
                                            <path
                                                d="M42 6l4.5 9.5 10 2-7.5 7.5L52 37l-9.5-4.5L33 37l-5-11-11-2L22 15 27 6z"
                                                fill="#ffffff"
                                                opacity="0.9"
                                            />
                                        </g>
                                        <g transform="translate(32,28)">
                                            <circle cx="23" cy="23" r="11" fill="#0ea5a4" />
                                            <path
                                                d="M23 9v-6M23 37v6M9 23h-6M37 23h6M14 14l-4-4M32 32l4 4M14 32l-4 4M32 14l4-4"
                                                stroke="#ffffff"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                            />
                                        </g>
                                    </svg>
                                </div>
                                <div>
                                    <h1 className="text-2xl font-semibold">Ведутся технические работы</h1>
                                    <p className="text-slate-500 leading-relaxed">
                                        Сейчас мы улучшаем сервис, скоро всё будет доступно. Спасибо за
                                        терпение — зайдите позже.
                                    </p>
                                    <div className="flex gap-3 mt-3 items-center">
                                        <a
                                            href="mailto:evgeniy.gudkov@napitkivmeste.ru"
                                            className="border border-slate-200 text-slate-600 px-4 py-2 rounded-lg font-medium hover:bg-slate-50 transition"
                                        >
                                            Связаться с нами
                                        </a>
                                    </div>
                                    <footer className="mt-3 text-sm text-slate-500">
                                        Ожидаем завершения — обычно работы занимают не более нескольких
                                        дней.
                                    </footer>
                                </div>
                            </div>
                        </section>
                        <aside className="flex flex-col gap-4 items-center p-5 border border-slate-100 rounded-xl bg-gradient-to-b from-white to-slate-50">
                            <div className="w-28 h-28 flex items-center justify-center bg-gradient-to-b from-slate-50 to-white rounded-lg p-3">
                                <svg
                                    width="80"
                                    height="80"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-label="Иконка часов"
                                >
                                    <circle cx="12" cy="12" r="10" fill="#ffffff" stroke="#e6eef0" />
                                    <path
                                        d="M12 7v6l4 2"
                                        stroke="#0f172a"
                                        strokeWidth="1.6"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        fill="none"
                                    />
                                </svg>
                            </div>
                            <div className="text-xs text-slate-500 text-center">
                                Мы работаем над улучшениями. Приносим извинения за неудобства.
                            </div>
                        </aside>
                    </div>
                </div>
                ||
                type === 'module' &&
                <div className="w-full max-w-xl mx-auto bg-white border border-slate-100 rounded-xl shadow-sm p-6 text-center flex flex-col items-center gap-4">
                    <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-b from-cyan-100/30 to-cyan-50 border border-cyan-100 rounded-lg">
                        <svg
                            width="60"
                            height="60"
                            viewBox="0 0 110 110"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-label="Технические работы"
                        >
                            <defs>
                                <linearGradient id="g2" x1="0" x2="1">
                                    <stop offset="0" stopColor="#06b6d4" />
                                    <stop offset="1" stopColor="#0891b2" />
                                </linearGradient>
                            </defs>
                            <circle cx="55" cy="55" r="52" fill="url(#g2)" opacity="0.1" />
                            <g transform="translate(30,30)">
                                <circle cx="25" cy="25" r="10" fill="#0ea5a4" />
                                <path
                                    d="M25 12v-6M25 38v6M12 25H6M38 25h6M17 17l-4-4M33 33l4 4M17 33l-4 4M33 17l4-4"
                                    stroke="#ffffff"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                            </g>
                        </svg>
                    </div>
                    <div>
                        <h2 className="text-lg font-semibold mb-1">Ведутся технические работы</h2>
                        <p className="text-slate-500 text-sm leading-relaxed">
                            Мы временно обновляем модуль. Пожалуйста, зайдите позже — работа скоро
                            будет завершена.
                        </p>
                    </div>
                    <a
                        href="#"
                        onClick={(e) => { e.preventDefault(); navigate("/") }}
                        className="mt-2 inline-block bg-cyan-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-cyan-700 transition"
                    >
                        На главную
                    </a>
                </div>
            }
        </>
    );
};

export default MaintenancePage;
